import { render, staticRenderFns } from "./pmdArbol.vue?vue&type=template&id=55fb2a80&"
import script from "./pmdArbol.vue?vue&type=script&lang=ts&"
export * from "./pmdArbol.vue?vue&type=script&lang=ts&"
import style0 from "./pmdArbol.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports